import { useTranslation } from "react-i18next";

import DefaultAuth from "./DefaultAuth";
import SignUpForm from "./Forms/SignUp";

function SignUp() {
	const { t } = useTranslation();

	return <DefaultAuth Form={SignUpForm} title={t("auth.createAccount")} />;
}

export default SignUp;
